import React from 'react'
import './ProfilePagePost.css'

function ProfilePagePost(props) {

  return (
    <div className='col'>      
        <img className='img-profile-post' src={window.location.origin + '/icon.jpg'} />
        <div className='profile-post-data col'>
          <p className='profile-post-title'>{props.data.title}</p>
          <p className='profile-post-date'>{props.data.date}</p>
        </div>
    </div>
  )
}

export default ProfilePagePost